const API_AUTH_USERNAME = "StaffManagement";
const API_AUTH_PASSWORD = "t746/mFxin8ks74or8hg";
const API_BASE_URL = "https://microdynamicsoftware.uk/StaffManagement/";
const MOBILE_NUMBER = 8888717711;
const EMAIL_ADDRESS = "info@microdynamicsoftware.com";
const COMPANY_ADDRESS = "103, Vitthal Complex, Near Selfy Point, Narhe, Pune, Maharashtra 411041"
const MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d121037.87258874883!2d73.9689319!3d18.5544842!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bc2c3cb9cccb1a1%3A0xc7b7afb550ce9499!2sButterfly%20Trampoline%20Park%20-%20Kharadi%20(Pune)%20HX39%2BRJJ%20Upper%20Kharadi%20Main%20Rd%2C%20Chokhi%20Dhani%20Pune%2C%20Maharashtra%20412207!3m2!1d18.554484199999997!2d73.9689319!5e0!3m2!1sen!2sin!4v1694072330060!5m2!1sen!2sin";
const FACEBOOK_URL = "https://www.facebook.com/MicrodynamicSoftware/";
const INSTGRAM_URL = "https://www.instagram.com/microdynamicsoftware/";
const LINKEDIN_URL = "https://in.linkedin.com/company/microdynamic-software";
const YOU_TUBE_URL = "https://www.youtube.com/channel/UCyHj5LJCasxUhLfrUtlzSZg";
export {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
  MOBILE_NUMBER,
  EMAIL_ADDRESS,
  FACEBOOK_URL,
  INSTGRAM_URL,
  LINKEDIN_URL,
  YOU_TUBE_URL,
  MAP_URL,
  COMPANY_ADDRESS
};
